import { AUTO_PIP, CUSTOM_AUTOSTART_RECORDING, CUSTOM_AUTOSTART_TRANSCRIPTION, CUSTOM_NOISE_SUPPRESSION, CUSTOM_NOISE_SUPPRESSION_TYPE, CUSTOM_PRE_JOIN_SCREEN, CUSTOM_PRE_JOIN_SCREEN_EXTERNAL, SELECTED_AUDIO_STATE, SELECTED_LANG_TRANSCRIPTION, SELECTED_VIDEO_STATE, SELECT_VISITOR_MUTE_STATE, UPDATE_IDS_VALUES_NOISE_SUPPRESSION } from './actionTypes';
export function toggleCustomNoiseSuppression(state) {
    return {
        type: CUSTOM_NOISE_SUPPRESSION,
        noiseSuppression: state
    };
}
export function toggleVisitorMuteButton(state) {
    return {
        type: SELECT_VISITOR_MUTE_STATE,
        visitorMute: state
    };
}
export function changeCustomNoiseSuppressionType(type) {
    return {
        type: CUSTOM_NOISE_SUPPRESSION_TYPE,
        newNoiseSuppressionType: type
    };
}
export function updateIdsValuesNoiseSuppression(deviceObject) {
    return {
        type: UPDATE_IDS_VALUES_NOISE_SUPPRESSION,
        deviceObject
    };
}
export function selectedLangTranscription(lang) {
    return {
        type: SELECTED_LANG_TRANSCRIPTION,
        lang
    };
}
export function selectedAudioState(audio) {
    return {
        type: SELECTED_AUDIO_STATE,
        audio
    };
}
export function selectedVideoState(video) {
    return {
        type: SELECTED_VIDEO_STATE,
        video
    };
}
export function toggleAutostartTranscription(state) {
    return {
        type: CUSTOM_AUTOSTART_TRANSCRIPTION,
        isTranscriptionAutostart: state
    };
}
export function toggleAutostartRecording(state) {
    return {
        type: CUSTOM_AUTOSTART_RECORDING,
        isRecordingAutostart: state
    };
}
export function togglePreJoinScreen(state) {
    return {
        type: CUSTOM_PRE_JOIN_SCREEN,
        isPreJoinScreen: state
    };
}
export function togglePreJoinScreenExternal(state) {
    return {
        type: CUSTOM_PRE_JOIN_SCREEN_EXTERNAL,
        isPreJoinScreenExternal: state
    };
}
export function toggleAutoPIP(state) {
    return {
        type: AUTO_PIP,
        isAutoPip: state
    };
}
